export const text = 'SCROLL DOWN FOR MORE DETAILS';
